import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-curso-view',
  templateUrl: './curso-view.component.html',
  styleUrls: ['./curso-view.component.scss'],
})
export class CursoViewComponent implements OnInit {
  @ViewChild('modalTodasAvaliacoes') modalTodasAvaliacoes: TemplateRef<any>;

  modalRef: BsModalRef;

  destaques = [
    {
      id: 1,
      dadoNumber: '+10000',
      dadoText: 'alunos formados',
    },
    {
      id: 2,
      dadoNumber: '+40',
      dadoText: 'aulas',
    },
    {
      id: 3,
      dadoNumber: '100%',
      dadoText: 'online',
    },
  ];

  listaAssuntos = [
    {
      id: 1,
      desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    },
    {
      id: 2,
      desc: 'Nulla et dui pretium ante pretium elementum.',
    },
    {
      id: 3,
      desc: 'Sed non dui id lorem lobortis euismod eu ut nulla.',
    },
  ];

  cardAvaliacoes = [
    {
      id: 1,
      imagem: './assets/img/sem-imagem.png',
      nomeCli: 'Joao Gomes',
      comentarioAval:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam viverra velit nec justo auctor rutrum.',
      avaliacao: '4,5',
    },
    {
      id: 1,
      imagem: './assets/img/sem-imagem.png',
      nomeCli: 'Joao Gomes',
      comentarioAval:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam viverra velit nec justo auctor rutrum.',
      avaliacao: '4,0',
    },
    {
      id: 1,
      imagem: './assets/img/sem-imagem.png',
      nomeCli: 'Joao Gomes',
      comentarioAval:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam viverra velit nec justo auctor rutrum.',
      avaliacao: '4,8',
    },
  ];

  avaliacoesGeral = [
    {
      id: 1,
      avaliacaoGeral: '4,4',
      totalAvaliacoes: '35',
    },
  ];

  beneficiosCurso = [
    {
      id: 1,
      beneficio: 'Curso 100% online',
    },
    {
      id: 2,
      beneficio: 'Acesso vitalicio',
    },
    {
      id: 1,
      beneficio: 'Curso 100% online',
    },
    {
      id: 2,
      beneficio: 'Acesso vitalicio',
    },
  ];

  perguntasFreq = [
    {
      id: 1,
      tituloFaq: 'Como funciona o certificado digital?',
      resposta:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam viverra velit nec justo auctor rutrum. In dolor lectus, aliquet id viverra accumsan, ultrices sed enim. Integer eget ante suscipit, mattis est vel,',
    },
    {
      id: 2,
      tituloFaq: 'Lorem ipsum dolor sit amet?',
      resposta:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam viverra velit nec justo auctor rutrum. In dolor lectus, aliquet id viverra accumsan, ultrices sed enim. Integer eget ante suscipit, mattis est vel,',
    },
    {
      id: 3,
      tituloFaq: 'Sed fringilla libero ut tellus bibendum?',
      resposta:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam viverra velit nec justo auctor rutrum. In dolor lectus, aliquet id viverra accumsan, ultrices sed enim. Integer eget ante suscipit, mattis est vel,',
    },
  ];

  criadorCurso = [
    {
      id: 1,
      nomeCriador: 'Ricardo camara',
      descricaoCR:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam viverra velit nec justo auctor rutrum In dolor lectus aliquet id viverra accumsan, ultrices sed enim.Integer eget ante suscipit, mattis est vel, congue sem.',
    },
  ];

  outrosProdutos = [
    {
      id: 1,
      imagem: './assets/img/sem-imagem.png',
      nomeCurso: 'Lorem ipsum',
      avaliacao: '4.8',
    },
    {
      id: 2,
      imagem: './assets/img/sem-imagem.png',
      nomeCurso: 'Lorem ipsum',
      avaliacao: '4.8',
    },
    {
      id: 2,
      imagem: './assets/img/sem-imagem.png',
      nomeCurso: 'Lorem ipsum',
      avaliacao: '4.8',
    },
    {
      id: 2,
      imagem: './assets/img/sem-imagem.png',
      nomeCurso: 'Lorem ipsum',
      avaliacao: '4.8',
    },
  ];

  constructor(private modalService: BsModalService) {}

  ngOnInit(): void {}

  abrirAvaliacoes() {
    this.modalRef = this.modalService.show(this.modalTodasAvaliacoes, {
      class: 'modal-dialog-centered modal-xl',
      keyboard: false,
      ignoreBackdropClick: true,
    });
  }

  decline() {
    this.modalRef.hide();
  }
}
